window.lang2 =
{
  "general": {
    "meta": {
      "tags": "已標籤",
      "page": "頁"
    },
    "404": {
      "click_here": "點擊這裡",
      "continue_shopping": "繼續購物",
      "title": "無法顯示頁面",
      "subtext_html": "您正在搜索的頁面可能已經刪除、更名或暫時不可用"
    },
    "breadcrumbs": {
      "home": "主頁",
      "cart": "購物車",
      "home_link_title": "回到主頁"
    },
    "newsletter_form": {
      "newsletter_email": "your-email@example.com",
      "submit": "提交",
      "newsletter_text": "請輸入電郵"
    },
    "search": {
      "no_results": "沒有結果",
      "title": "搜尋產品",
      "placeholder": "搜尋",
      "submit": "搜尋",
      "view_results": "查看所有結果"
    },
    "currency": {
      "currency": "貨幣",
      "change_text": "The store's currency changed to"
    },
    "language": {
      "language": "語言"
    },
    "sidebar": {
      "sidebar_more": "目錄"
    }
  },
  "blogs": {
    "article": {
      "older_post": "較舊文章",
      "newer_post": "較新文章",
      "tags": "標籤",
      "read_more": "更多",
      "author_on_date_html": "由((作者author))發佈於((日期date))",
      "comment_meta_html": "{{ author }} on {{ date }}"
    },
    "comments": {
      "name": "你的姓名",
      "email": "你的電郵",
      "message": "你的意見",
      "post": "回應",
      "title": "留下意見",
      "moderated": "請注意，評論須經過審核才發佈。",
      "success_moderated": "你的評論已成功上載，將於審核後發佈。",
      "success": "你的評論已成功上載，感謝你的支持！",
      "note": "所以評論已於發佈前審核。",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "sidebar": {
      "recent_articles": "最新文章",
      "tag_cloud": "Tag cloud",
      "categories": "分類"
    }
  },
  "cart": {
    "general": {
      "title": "我的購物車",
      "remove": "刪除",
      "note": "賣方的操作指南",
      "subtotal": "合共",
      "shipping_at_checkout": "結帳時已計算運費及稅額",
      "update": "更新購物車",
      "checkout": "付款",
      "button_checkout": "結帳",
      "empty": "你的購物車內沒有產品",
      "continue_browsing_html": "繼續瀏覽",
      "view_cart": "查看購物車",
      "close_cart": "關閉",
      "shopping_cart": "購物車",
      "cart_supermarket": "購物車",
      "label": "備註",
      "label_text": "額外意見",
      "shipping_calculator_button": "計算運費",
      "shipping_calculator_calculating": "計算中..",
      "shipping_calculator_error_message": "錯誤：請輸入正確寄送資料",
      "shipping_calculator_success_one_rate": "只有一種合適的運費適用",
      "shipping_calculator_success_no_rate": "暫時該寄送地址沒有運費適用",
      "shipping_calculator_success_at": "於",
      "shipping_calculator_success_many_rates": {
        "there_are": "這裡有",
        "shipping_rates_available_for": "可用的運費",
        "starting_at": "，由"
      }
    },
    "label": {
      "product": "產品",
      "price": "價錢",
      "quantity": "數量",
      "total": "總數",
      "or": "或",
      "quick_cart": "購物車",
      "your_order": "您的訂單",
      "order_summary": "訂單概覽"
    },
    "ajax_cart": {
      "continue_shopping": "繼續購物",
      "go_to_cart": "查看購物車",
      "success_text": "is added to your shopping cart",
      "error": "錯誤",
      "loading": "載入中",
      "close": "關閉",
      "popup_cart_des": "The following items have been added to your cart:",
      "items_in_your_cart": "在您購物車中的產品"
    }
  },
  "slideshow": {
    "next_slide": "下一頁",
    "previous_slide": "上一頁",
    "pause_slideshow": "暫停幻燈片",
    "play_slideshow": "播放幻燈片",
    "play_video": "播放短片",
    "close_video": "關閉短片"
  },
  "collections": {
    "general": {
      "title": "系列",
      "no_matches": "很抱歉，這系列暫時沒有任何產品。",
      "link_title": "瀏覽((title))系列",
      "grid_view": "網格",
      "list_view": "列表",
      "shop_now": "Shop now",
      "shop_the_collection": "選購系列",
      "show_more": "顯示更多",
      "no_more_product": "沒有更多產品",
      "items_count": {
        "one": "產品",
        "other": "產品"
      },
      "items_with_count": {
        "one": "{{ count }} 件產品",
        "other": "{{ count }} 件產品"
      }
    },
    "sidebar": {
      "types": "產品類別",
      "vendors": "供應商",
      "tags": "標籤",
      "clear": "清除",
      "clear_all": "清除所有",
      "refined_by": "精製",
      "sidebar_more": "精製"
    },
    "sorting": {
      "title": "標題",
      "featured": "精選",
      "best_selling": "熱賣產品",
      "az": "Alphabetically, A-Z",
      "za": "Alphabetically, Z-A",
      "price_ascending": "價格從低到高",
      "price_descending": "價格從高到低",
      "date_descending": "日期從新到舊",
      "date_ascending": "日期從舊到新"
    },
    "toolbar": {
      "view_as": "查看",
      "item_per_page": "每頁數量",
      "previous": "檢視",
      "next": "下一個",
      "show": "顯示",
      "showing": "顯示",
      "all": "所有",
      "of": "of"
    }
  },
  "contact": {
    "form": {
      "name": "你的姓名",
      "email": "你的電郵",
      "address": "你的地址",
      "phone": "你的電話",
      "message": "你的意見",
      "placeholder_message": "請留下意見",
      "send": "發送",
      "submit_contact": "提交聯絡資料",
      "send_question": "提交問題",
      "post_success": "感謝聯絡我們，同事會盡快聯絡你。"
    }
  },
  "customer": {
    "account": {
      "title": "我的帳戶",
      "details": "帳戶詳細資料",
      "view_addresses": "查看地址",
      "return": "回到帳戶資料"
    },
    "activate_account": {
      "title": "激活帳戶",
      "subtext": "建立密碼以激活帳戶",
      "password": "密碼",
      "password_confirm": "確認密碼",
      "submit": "激活帳戶",
      "cancel": "拒絕邀請"
    },
    "addresses": {
      "title": "客戶地址",
      "default": "預設",
      "add_new": "新增地址",
      "edit_address": "更改地址",
      "first_name": "名字",
      "last_name": "姓",
      "company": "公司",
      "address1": "地址1",
      "address2": "地址2",
      "city": "城市",
      "country": "國家",
      "province": "省份",
      "zip": "郵政區號",
      "phone": "電話",
      "set_default": "設為默認地址",
      "add": "增加地址",
      "update": "更新地址",
      "cancel": "取消",
      "edit": "更改",
      "delete": "移除",
      "delete_message": "你確定刪除這地址嗎？"
    },
    "logout": {
      "title": "客戶"
    },
    "login": {
      "title": "用戶登入",
      "account": "帳戶",
      "returning_customer": "舊客戶",
      "new_customer": "新客戶",
      "email": "電郵",
      "password": "密碼",
      "forgot_password": "忘記密碼？",
      "sign_in": "登入",
      "login": "登入",
      "cancel": "回到網店",
      "guest_title": "以訪客身份繼續使用",
      "guest_continue": "繼續"
    },
    "orders": {
      "title": "訂單歷史",
      "order_number": "訂單",
      "date": "日期",
      "payment_status": "支付狀態",
      "fulfillment_status": "執行狀態",
      "total": "合共",
      "none": "沒有任何訂單紀錄。"
    },
    "order": {
      "title": "訂單 {{ name }}",
      "date": "訂單 {{ date }}",
      "cancelled": "訂單已於 {{ date }} 取消",
      "cancelled_reason": "原因：{{ reason }}",
      "billing_address": "帳單地址",
      "payment_status": "支付狀態",
      "shipping_address": "送貨地址",
      "fulfillment_status": "執行狀態",
      "discount": "折扣",
      "shipping": "運費",
      "tax": "稅",
      "product": "產品",
      "sku": "Sku",
      "price": "價錢",
      "quantity": "數量",
      "total": "合共",
      "fulfilled_at": "達成於",
      "subtotal": "小計"
    },
    "recover_password": {
      "title": "重設密碼",
      "email": "電郵",
      "submit": "提交",
      "cancel": "取消",
      "subtext": "將發送重設密碼連結的電郵給你",
      "success": "已發送更新密碼連結的電郵"
    },
    "reset_password": {
      "title": "重設帳戶",
      "subtext": "請輸入新密碼",
      "password": "密碼",
      "password_confirm": "確認密碼",
      "submit": "重設密碼"
    },
    "register": {
      "title": "申請帳戶",
      "register": "註冊",
      "first_name": "名字",
      "last_name": "姓",
      "email": "你的電郵",
      "password": "你的密碼",
      "submit": "申請帳戶",
      "cancel": "回到網店"
    },
    "form": {
      "error_message": "抱歉，請輸入正確資料再按確認。"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "頭版系列",
      "featured_title": "精選系列",
      "news_title": "最新消息"
    },
    "onboarding": {
      "modal_title": "即將完成..",
      "add_product": "增加產品",
      "no_products_html": "You have no products in your Frontpage collection. This placeholder will appear until you <a href=\"\/admin\/collections?tutorial=Frontpage\">add a product to this collection<\/a>.",
      "product_title": "產品名稱範本",
      "no_collections_html": "You don't have any collections to show here. <a href=\"\/admin\/custom_collections\">Add some collections<\/a> to go along with the default Frontpage.",
      "add_collection": "增加系列",
      "collection_title": "系列標題範本"
    },
    "show_more": "顯示更多",
    "no_more_product": "沒有更多產品"
  },
  "layout": {
    "cart": {
      "title": "購物車",
      "items_count": {
        "one": "產品",
        "other": "產品"
      }
    },
    "customer": {
      "account": "帳戶",
      "logged_in_as_html": "登入為 {{ first_name }}",
      "log_out": "登出",
      "log_in": "登入",
      "create_account": "申請帳戶",
      "register": "註冊",
      "title": "我的帳戶"
    },
    "footer": {
      "linklist_title": "快速連結",
      "social_title": "已連結",
      "newsletter_title": "電郵",
      "accepted_payments": "接受付款"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous Product",
      "next_product_html": "Next Product &rarr;",
      "from": "由"
    },
    "product": {
      "sale": "減價",
      "you_save": "您節省了",
      "custom_label": "自定標籤",
      "bundle_label": "捆綁",
      "new_label": "新",
      "sold_out": "售罄",
      "on_sale_from_html": "<strong>On Sale<\/strong> from {{ price }}",
      "unavailable": "不適用",
      "compare_at": "比較於",
      "quantity": "數量",
      "add_to_cart": "加入購物車",
      "add_all_to_cart": "全部加入購物車",
      "buy_now": "馬上購買",
      "add": "增加",
      "select_options": "選擇選項",
      "quick_view": "快速查看",
      "in_stock": "現貨",
      "out_of_stock": "售罄",
      "many_in_stock": "庫存很多",
      "details": "詳細資料",
      "from": "由",
      "show_options": "顯示選項",
      "hide_options": "隱藏選項",
      "adding": "增加",
      "thank_you": "謝謝",
      "add_more": "添加更多",
      "cart_feedback": "已加入",
      "main_product": "這件產品"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "請是你可用於 {{ shop }} 的 {{ value }} 禮品卡",
      "subtext": "這是你的禮品卡！",
      "disabled": "不適用",
      "expired": "於 {{ expiry }} 到期",
      "active": "於 {{ expiry }} 到期",
      "redeem": "結帳時使用優惠碼兌換禮品卡",
      "shop_link": "開始購物",
      "print": "列印"
    }
  },
  "wishlist": {
    "general": {
      "my_wishlist": "我的願望清單",
      "wishlist": "願望清單",
      "product_image": "圖片",
      "product_name": "產品名稱",
      "unit_price": "價錢",
      "share_wishlist": "方過電郵分享願望清單",
      "no_login_html": "To create a wish list you must <a href=\"\/account\/login\">sign in<\/a> or <a href=\"\/account\/register\">create an account<\/a>.",
      "add_to_wishlist": "添加到願望清單",
      "remove_wishlist": "刪除願望清單",
      "note": "已加入你的願望清單，進入願望清單",
      "subtext": "建立的願望清單",
      "sign_in": "登入",
      "or": "或",
      "wishlist_empty": "你的願望清單仍然為空...",
      "create_account": "申請帳戶"
    }
  },
  "discount_ninja": {
    "from": "由",
    "here": "這裡",
    "free": "免費",
    "sold_out": "售罄"
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  }
}
